<template>
    <slider-layout is-show-overlay gray-bg>

            <div class="col-lg-10 ml-auto mr-auto mt-3">
              <card>
                <!-- <button type="button" class="pull-right close" @click="$router.push('/home')">X</button> -->
              <h4 class="header text-center">광고주/대행사 담당자 회원가입</h4>
              <hr class="mb-4"/>
              <el-form @submit.native.prevent="submitForm('ruleForm')" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="160px" class="mr-5">
                <p class="text-center mb-4 fs15 text-primary2">광고주의 담당자만 가입이 가능합니다. 회원가입을 위해 아래의 정보를 기입하세요</p>
                <el-form-item label="광고주" prop="companySeq" required>
                  <el-row :gutter="12">
                    <div v-disabled-fieldset="confirmLicens">
                    <search-company cls="pl-0" 
                    v-model="ruleForm.companySeq"  
                    :is-user-company="true"
                    :keyword-span="5" 
                    :company-span="12" 
                    :showLabel="false" 
                    @selected="companySelected"></search-company>  
                    </div>
                  </el-row>
                </el-form-item>

                <div v-disabled-fieldset="!ruleForm.companySeq || confirmLicens">
                <el-form-item label="사업자 등록번호" required>
                    <!-- <span class="text-primary2 fs18 ml-3">{{licenseNumber.substring(0,5) + '*****'}}</span> -->
                    <!-- <el-col :span="3" class="text-danger" >(직접입력)</el-col> -->
                    <sabun-input v-model="ruleForm.sabun" ></sabun-input>
                    <el-col :span="4" v-if="!confirmLicens">
                      <el-button class="ml-3" type="danger" @click="checkSabun" size="sm">번호확인</el-button>
                    </el-col>
                    <el-col :span="4" v-if="confirmLicens" class="ml-2 text-primary2 fs15">
                      정보일치
                    </el-col>
                </el-form-item>
                </div>

                <hr class=""/>

                <div v-disabled-fieldset="!confirmLicens">
                <el-form-item label="아이디 (이메일)" required>
                  <el-col :span="6">
                    <el-form-item prop="emailId">
                      <el-input v-model="ruleForm.emailId" ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col class="text-center" :span="2">@</el-col>
                  <el-col :span="6">
                    <el-form-item prop="emailDomain" >
                      <el-input v-model="ruleForm.emailDomain" ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="4" class="ml-3" v-if="email && ruleForm.emailId && ruleForm.emailDomain && !idSuccess">
                    <el-button type="danger" @click="existsUserId" size="sm">중복확인</el-button>
                  </el-col>
                  <el-col :span="4" class="ml-1" v-if="idSearch">
                    <span class="ml-3 text-success fs16" v-if="idSuccess === true">
                      <i class="el-icon-success"></i><span class="ml-1 valign-middle"> 사용가능</span>
                    </span>
                    <span class="text-danger fs16"  v-if="idSuccess === false">
                      <i class="el-icon-error"></i><span class="ml-1 valign-middle"> 사용불가</span>
                    </span>

                  </el-col>
                </el-form-item>

                <el-form-item label="담당자 성명" prop="userName" required>
                  <el-input v-model="ruleForm.userName" ></el-input>
                </el-form-item>
                
                <el-form-item label="비밀번호" prop="password" required>
                  <el-input type="password" v-model="ruleForm.password" ></el-input>
                </el-form-item>
                <el-form-item label="비밀번호 확인" prop="confirmPassword" required>
                  <el-input type="password" v-model="ruleForm.confirmPassword" ></el-input>
                </el-form-item>


                <el-form-item label="부서" prop="department" required>
                  <el-input v-model="ruleForm.department" ></el-input>
                </el-form-item>

                <el-form-item label="휴대폰" prop="phone1" required>
                  <tel-input v-model="ruleForm.phone1" ></tel-input>
                </el-form-item>

                <el-form-item label="사무실번호" prop="phone2">
                  <tel-input v-model="ruleForm.phone2" ></tel-input>
                </el-form-item>


                <el-form-item label="보안문자" prop="captcha" required>
                  <el-input v-model="ruleForm.captcha" style="width: 120px;"></el-input>
                  <img class="ml-3" :src="captcha" /> <el-button @click="changeCaptchaUrl" class="ml-2" size="mini" round><i class="el-icon-refresh"></i> 새로고침</el-button>
                </el-form-item>

                <el-form-item class="text-right mt-5">
                  <el-button native-type="submit" type="primary" icon="el-icon-user">회원 가입</el-button>
                  <el-button @click="$router.push('/home')" icon="el-icon-house">메인으로 이동</el-button>
                </el-form-item>
                </div>
              </el-form>
              </card>
            </div>

    </slider-layout>

</template>
<script>
  import JoinInfoProtectionModal from '../Common/JoinInfoProtectionModal.vue';
  import AppFooter from 'src/components/Pages/Views/Layout/AppFooter'
  import SearchCompany from '@/components/Pages/Views/Common/SearchCompany.vue'
  import TelInput from '@/components/Pages/Views/Common/TelInput.vue'
  import SabunInput from '@/components/Pages/Views/Common/SabunInput.vue';
  import CommonProxy from '@/proxies/CommonProxy';
  import * as Util from '@/util/util'
  import _ from 'lodash'
  import SliderLayout from './Layout/SliderLayout.vue';

  const validator =({required, onlyWord, domain, min, confirmPassword, phone, captcha, tel, pwd}, vm) => {

    return (rule, value, callback) => {
      
      if(required && !value) {
        callback( new Error('필수입력 항목입니다.'))
        return
      } else if(onlyWord && !/^[\w\-\.]+$/g.test(value) ) {
          callback( new Error('영문만 가능합니다.'))
          return
      } else if(domain && !/[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/.test(value) ) {
          callback( new Error('이메일 형식만 가능합니다. ex)gmail.com'))
          return
      } else if(pwd && !/^(?=.*?[#?!@$ %^&*-]).{6,}$/.test(value)) {
          callback( new Error(`특수 문자 포함 6자 이상 입력하세요.`))
          return
      } else if(min && value.length < min ) {
          callback( new Error(`최소 ${min}자리 이상 이어야 합니다.`))
          return
      } else if(confirmPassword && value !== vm.ruleForm[confirmPassword] ) {
          callback( new Error('비밀번호가 일치하지 않습니다.'))
          return
      } else if(phone  && !/^\d+\-\d+\-\d+$/g.test(value) ) {
          callback( new Error('필수이고 숫자만 가능합니다.'))
          return
      } else if(tel && value &&  !/^\d*\-\d*\-\d*$/g.test(value) ) {
          callback( new Error('숫자만 가능합니다.'))
          return
      } else if(captcha) {
        vm.debouncedCaptchaAnswer( value, callback )

      } else {
        callback()
      }

      
    }

  } 

  export default {
    components: {
      AppFooter,
      SearchCompany,
      TelInput,
      SabunInput,
      SliderLayout,
    },
    created() {
      this.debouncedCaptchaAnswer = _.debounce(this.capchaValid, 800)
      
    },
    mounted() {

      this.$modal.show(
        JoinInfoProtectionModal, 
        { },
        { width:'600px', /*height: '90%',*/ escToClose: false },
        { }
      )


    },
    methods: {
        checkSabun() {

          if(!this.ruleForm.sabun) {
            alert('사업자등록번호를 입력해 주세요')
            return
          }
          // 2128127329
          new CommonProxy()
          .validLicense( this.ruleForm.companySeq, this.ruleForm.sabun)
          .then(response => {
            if(!response.success) {
              alert('사업자등록번호가 일치하지 않습니다.\n다시 확인하시기 바랍니다.')
            } else {
              alert('사업자등록번호가 확인 되었습니다.\n가입에 필요한 항목들을 입력해 주세요.')
              this.confirmLicens = true

            }
          })

        },
        capchaValid( value, callback ) {

          new CommonProxy()
          .validCaptcha(value)
          .then(response => {
            if(!response.success) {
              callback( new Error('보안문자가 일치하지 않습니다.'))
            } else {
              callback()
            }
          })

        },
        companySelected( {licenseNumber} ) {
            this.confirmLicens = false   
          //  this.ruleForm.sabun = ''       
          // this.licenseNumber = licenseNumber
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
              if (valid) {
                  if(!this.idSuccess) {
                      alert('아이디 중복확인이 필요합니다.')
                      return false
                  }

                  new CommonProxy()
                  .createUser( this.ruleForm )
                  .then(response => {
                    if(!response.success) {
                      alert(response.header.resultMessages)
                    } else {
                      if(response.status === 'READY') {
                        alert('회원가입 처리가 완료됐습니다.\n가입승인 이후 로그인이 가능합니다.\n빠른 승인을 원하시면 홈페이지 하단에 나와있는 \n대표전화로 문의바랍니다.')
                      } else if(response.status === 'OK') {
                        alert('회원가입이 완료됐습니다.\n로그인 후 이용하시기 바랍니다.')
                      }  
                      this.$router.push('/home')
                    }
                  })

              } else {
                  alert('회원정보 및 보안문자를 올바르게 입력해주세요')
                  return false;
              }
            })
        },
        existsUserId() {
          //const vm = this
          new CommonProxy().existsUserId( this.email )
          .then(response => {
            this.idSearch = true
            this.idSuccess = response.success
          })
        },
        changeCaptchaUrl() {
          this.captcha = '/api/common/captcha' + '?' + Util.random(1,10000)
          return this.captcha
        }
    },
    computed: {
      email() {
        this.idSearch = false
        this.idSuccess = undefined
        this.ruleForm.email = this.ruleForm.emailId+'@'+this.ruleForm.emailDomain
        this.ruleForm.userId = this.ruleForm.email
        return this.ruleForm.email
      },
    },
    data() {
      return {
        confirmLicens: false,
        count: 0,
        captcha: this.changeCaptchaUrl(),
        idSearch: false,
        idSuccess: undefined,
        licenseNumber: '',
        ruleForm: {
          companySeq: '',
          userId: '',
          email: '',
          password: '',
          confirmPassword: '',
          userName: '',
          department: '',
          phone1: '',
          phone2: '',
          sabun: '',
          captcha: '',
          masterYn: 'N',
        },
        rules: {
          companySeq: [
            { trigger: 'change', validator: validator({ required: true }) }
          ],
          emailId: [
            { trigger: 'blur', validator: validator({ required: true, onlyWord: true }) },
            { trigger: 'change', validator: validator({ required: true, onlyWord: true }) }
          ],
          emailDomain: [
            { trigger: 'blur', validator: validator({ required: true, domain: true }) },
            { trigger: 'change', validator: validator({ required: true, domain: true }) }
          ],
          password: [
            { trigger: 'blur', validator: validator({ required: true, pwd: true, min: 6 }) },
            { trigger: 'change', validator: validator({ required: true, pwd: true, min: 6 }) }
          ],
          confirmPassword: [
            { trigger: 'blur', validator: validator({ required: true, confirmPassword: 'password' }, this) },
            { trigger: 'change', validator: validator({ required: true, confirmPassword: 'password'}, this) }
          ],
          userName: [
            { trigger: 'blur', validator: validator({ required: true}) },
            { trigger: 'change', validator: validator({ required: true}) },
          ],
          department: [
            { trigger: 'blur', validator: validator({ required: true}) },
            { trigger: 'change', validator: validator({ required: true}) },
          ],
          phone1: [
            { trigger: 'input', validator: validator({ required: true, phone: true}) },
            { trigger: 'blur', validator: validator({ required: true, phone: true}) }
          ],
          phone2: [
            { trigger: 'input', validator: validator({ tel: true}) },
            { trigger: 'blur', validator: validator({ tel: true}) }
          ],
          captcha: [
            { trigger: 'change', validator: validator({ required: true, captcha: true}, this) },
            { trigger: 'blur', validator: validator({ required: true, captcha: true}, this) },
          ],
          sabun: [
            { trigger: 'input', validator: validator({ required: true}) },
            { trigger: 'blur', validator: validator({ required: true}) }
          ],

        }
      }
    }
  }
</script>
<style>
  .join-page {
    background-image: url(/static/commons/images/main_bg.jpg);
    min-height: 100vh;
    background-size: cover;
  }  
  .join-page .logo {width: 221px;height: 64px;background: url("/static/commons/images/main_logo.png") no-repeat; margin:0 auto;position: absolute;background-size: contain;z-index: 1000;margin: 30px;}

  .join-page .card label {
    color: #606266;
    font-size: 14px;
  }

</style>
